import { render, staticRenderFns } from "./dayTopicDetail.vue?vue&type=template&id=72e482ea&"
import script from "./dayTopicDetail.vue?vue&type=script&lang=js&"
export * from "./dayTopicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports